// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies
// @generated from protobuf file "backend/span_export_service.proto" (package "tusk.drift.backend.v1", syntax proto3)
// tslint:disable
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { SpanExportService } from "./span_export_service";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { ExportSpansResponse } from "./span_export_service";
import type { ExportSpansRequest } from "./span_export_service";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service tusk.drift.backend.v1.SpanExportService
 */
export interface ISpanExportServiceClient {
    /**
     * @generated from protobuf rpc: ExportSpans
     */
    exportSpans(input: ExportSpansRequest, options?: RpcOptions): UnaryCall<ExportSpansRequest, ExportSpansResponse>;
}
/**
 * @generated from protobuf service tusk.drift.backend.v1.SpanExportService
 */
export class SpanExportServiceClient implements ISpanExportServiceClient, ServiceInfo {
    typeName = SpanExportService.typeName;
    methods = SpanExportService.methods;
    options = SpanExportService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: ExportSpans
     */
    exportSpans(input: ExportSpansRequest, options?: RpcOptions): UnaryCall<ExportSpansRequest, ExportSpansResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<ExportSpansRequest, ExportSpansResponse>("unary", this._transport, method, opt, input);
    }
}
